<template lang="pug">
div
  domain-form-dialog(ref="domainsDialog", @error='onCreateDomainError', @created='onCreateDomainSuccess')

  .md-headline Domains
  .md-subheading.player-size Mode
  md-radio.md-primary(v-model='entity.outletList.mode', md-value='whitelist') Approved Domain List
  md-radio.md-primary(v-model='entity.outletList.mode', md-value='blacklist') Blocked Domain List
  // Domains
  md-layout
    md-layout(md-flex='95')
      md-input-container()
        label(for='domains') Domains
        md-select#domains.form-controls(multiple, v-model='entity.outletList.domainLists')
          md-option(v-for='domain in domains', :value='domain._id' :key="domain._id") {{ domain.name }}
    md-layout.add-domain-button(md-flex='5')
      md-button.md-icon-button.md-raised.md-dense.md-mini(@click='openDomainsFormDialog')
        md-icon(md-iconset="fa fa-plus")
</template>

<script>
  import domainService from '../../services/domainService';
  import DomainFormDialog from './DomainFormDialog';

  export default {
    components: {
      DomainFormDialog
    },
    props: {
      entity: {
        type: Object,
        required: true
      }
    },
    data() {
      return {
        domains: []
      };
    },
    methods: {
      openDomainsFormDialog() {
        this.$refs.domainsDialog.open();
      },
      onCreateDomainSuccess(domain) {
        this.domains.push(domain);
        this.entity.outletList.domainLists.push(domain._id);
        this.$emit('created', 'Domain created successfully');
      },
      onCreateDomainError(error) {
        this.$emit('error', error);
      }
    },
    mounted() {
      const params = {
        limit: 200,
        sortBy: 'name',
        sortOrder: 1,
        status: 'public'
      };
      domainService.getList(params)
        .then((response) => {
          this.domains = response.data.domainLists;
        });
    }
  };
</script>

<style lang="scss">
  .info-tooltip {
    cursor: pointer;
  }
  .md-select-value {
    white-space: normal;
  }
  .add-domain-button {
    align-items: center;
  }
</style>



// WEBPACK FOOTER //
// src/shared-components/forms/DomainsForm.vue